export enum TutTutCustomErrorCodes {
  TT_ORDER_CREATION_ERROR = "TT_ORDER_CREATION_ERROR",
  TT_ORDER_CANCELLATION_ERROR = "TT_ORDER_CANCELLATION_ERROR",
  TT_ORDER_UPDATING_ERROR = "TT_ORDER_UPDATING_ERROR",
  TT_ORDER_DELETION_ERROR = "TT_ORDER_DELETION_ERROR",
  TT_UNEXPECTED_NEW_ORDER_STATUS_API = "TT_UNEXPECTED_NEW_ORDER_STATUS_API",
}

export enum ParcelCollectionErrorCodes {
  PARCEL_NOT_FOUND = "PARCEL_NOT_FOUND",
  RRF_NOT_FOUND = "RRF_NOT_FOUND",
  PARCEL_ALREADY_RETURNING = "PARCEL_ALREADY_RETURNING",
  DIFFERENT_ORDER = "DIFFERENT_ORDER",
  UNACCEPTABLE_PARCEL_STATUS = "UNACCEPTABLE_PARCEL_STATUS",
  NOT_BTOC_ORDER = "NOT_BTOC_ORDER",
  NO_CARRIER_ID = "NO_CARRIER_ID",
  NOT_A_CARRIER = "NOT_A_CARRIER",
  NO_AUTO_RETURN = "NO_AUTO_RETURN",
  CARRIER_NOT_FOUND = "CARRIER_NOT_FOUND",
  CARRIER_CANT_COLLECT = "CARRIER_CANT_COLLECT",
  CARRIER_IRRELEVANT_FOR_ADDRESS = "CARRIER_IRRELEVANT_FOR_ADDRESS",
  CARRIER_IRRELEVANT_FOR_COMPANY = "CARRIER_IRRELEVANT_FOR_COMPANY",
  UNACCEPTABLE_SHIPMENT_TYPE = "UNACCEPTABLE_SHIPMENT_TYPE",
  DETAILS_MISSING = "DETAILS_MISSING",
}

export enum ParcelScanningErrorCodes {
  NON_NULLABLE_RAW = "Raw data cannot be null when scanning",
  MISSING_EXPECTED_DATA = "MISSING_EXPECTED_DATA",
  DIGITAL_SIGNATURE_EXPECTED = "DIGITAL_SIGNATURE_EXPECTED",
  NON_EXISTING_ADDRESS = "Keeper or address does not exist",
  NO_REASSIGNMENT_KEEPER_IS_TOO_FAR = "NO_REASSIGNMENT_KEEPER_IS_TOO_FAR",
  NOT_FOR_THE_SAME_UNANNOUCED = "Unnanounced parcel not for the same client",
  // Parcel No not recognized or not allowed for dropoff
  PARCEL_NOT_RECOGNIZED = "PARCEL_NOT_RECOGNIZED",
  OPTION_IS_NOT_COVERED = "OPTION_IS_NOT_COVERED",
  NOT_SAME_CLIENT_ORDER = "NOT_SAME_CLIENT_ORDER",
  ALREADY_AT_HOME = "ALREADY_AT_HOME",
  NOT_FOR_DELIVERY = "Ce colis n'est pas à réceptionner",
  NOT_FOR_RETURNING = "Ce colis n'est pas à retourner",
  WRONG_DELIVERY_CODE = "WRONG_DELIVERY_CODE",
  DELIVERY_REFUSED = "DELIVERY_REFUSED",
  UNKNOWN_ERROR = "UNKNOWN_ERROR",
  NO_DELIVERY_CODE = "NO_DELIVERY_CODE",
  CARRIER_PROCESSING_ERROR = "CARRIER_PROCESSING_ERROR",
}

export const getErrorMessage = (
  errorCode: TutTutCustomErrorCodes | ParcelCollectionErrorCodes | ParcelScanningErrorCodes | string,
) => {
  switch (errorCode) {
    // TutTutCustomErrorCodes cases
    case TutTutCustomErrorCodes.TT_ORDER_CREATION_ERROR:
      return "Erreur lors de la création de la commande Tut Tut"
    case TutTutCustomErrorCodes.TT_ORDER_CANCELLATION_ERROR:
      return "Erreur lors de l’annulation de la commande Tut Tut"
    case TutTutCustomErrorCodes.TT_ORDER_UPDATING_ERROR:
      return " Erreur lors de la mise à jour de la commande Tut Tut"
    case TutTutCustomErrorCodes.TT_ORDER_DELETION_ERROR:
      return "Error deleting the order in TutTut"
    case TutTutCustomErrorCodes.TT_UNEXPECTED_NEW_ORDER_STATUS_API:
      return "Statut de commande inattendu dans l’API Tut Tut"

    // ParcelCollectionErrorCodes cases
    case ParcelCollectionErrorCodes.PARCEL_NOT_FOUND:
      return "Colis introuvable"
    case ParcelCollectionErrorCodes.RRF_NOT_FOUND:
      return "Formulaire de demande de retour introuvable. Veuillez vérifier l’ID RRF fourni"
    case ParcelCollectionErrorCodes.PARCEL_ALREADY_RETURNING:
      return "Le colis est déjà en cours de retour. L’action ne peut pas être traitée"
    case ParcelCollectionErrorCodes.DIFFERENT_ORDER:
      return "Les colis doivent appartenir à la même commande. Veuillez vérifier les détails de la commande et réessayer"
    case ParcelCollectionErrorCodes.UNACCEPTABLE_PARCEL_STATUS:
      return "Le colis n’est pas éligible pour la planification du retour. Veuillez vérifier son statut"
    case ParcelCollectionErrorCodes.NOT_BTOC_ORDER:
      return "Commande non compatible B2C"
    case ParcelCollectionErrorCodes.NO_CARRIER_ID:
      return "Identifiant transporteur manquant"
    case ParcelCollectionErrorCodes.NOT_A_CARRIER:
      return "Échec de la vérification du transporteur. Veuillez confirmer l’éligibilité du transporteur"
    case ParcelCollectionErrorCodes.NO_AUTO_RETURN:
      return "Le retour automatique n’est actuellement pas pris en charge pour cette demande"
    case ParcelCollectionErrorCodes.CARRIER_NOT_FOUND:
      return "Transporteur introuvable"
    case ParcelCollectionErrorCodes.CARRIER_CANT_COLLECT:
      return "Le transporteur ne peut pas collecter le colis"
    case ParcelCollectionErrorCodes.CARRIER_IRRELEVANT_FOR_ADDRESS:
      return "Transporteur inadapté pour cette adresse"
    case ParcelCollectionErrorCodes.CARRIER_IRRELEVANT_FOR_COMPANY:
      return "Transporteur inadapté pour cette entreprise"
    case ParcelCollectionErrorCodes.UNACCEPTABLE_SHIPMENT_TYPE:
      return "Type d’expédition invalide pour le retour. Veuillez vérifier les détails de l’expédition"
    case ParcelCollectionErrorCodes.DETAILS_MISSING:
      return "Des détails supplémentaires sont requis lorsque ‘AUTRE’ est sélectionné comme motif de retour"

    // ParcelScanningErrorCodes cases
    case ParcelScanningErrorCodes.CARRIER_PROCESSING_ERROR:
      return "UPS n'a pas validé la livraison. Vérifiez le code fourni par Keeper"

    default:
      return errorCode
  }
}
